import {
    AppBar, AppContainer, AppContent, AppLayout, AppNav, AuthContext, Menu,
    MenuItem, Text, UserMenu
} from "@tv2no/ui-react";
import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import { Front } from "./Front";
import { GeoLists } from "./geo/GeoLists";
import { DataImport } from "./import/DataImport";
import { TaxYearEdit } from "./import/tax/edit/TaxYearEdit";
import { PersonListEdit } from "./lists/PersonListEdit";
import { PersonLists } from "./lists/PersonLists";
import { SystemInfo } from "./main/SystemInfo";
import { PersonSearch } from "./search/PersonSearch";

const Root = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const auth = useContext(AuthContext);

    useEffect(() => {
        setIsAdmin(auth && auth.data && auth.data.roles === "ROLE_ADMIN");
    }, [auth]);

    return (
        <AppContainer>
            <AppLayout>
                <AppBar title="Skattelister">
                    <AppBar.Item placeRight>
                        <UserMenu name={auth?.data?.fullName} about={auth?.data?.email}>
                            <Menu>
                                <MenuItem icon="sign-out" label="Logg ut" onClick={auth.logout} />
                            </Menu>
                        </UserMenu>
                    </AppBar.Item>
                </AppBar>
                <AppNav
                    title={
                        <Text block size="large" weight="bold">
                            Skattelister
                        </Text>
                    }
                >
                    <AppNav.Menu>
                        <AppNav.MenuItem icon="search" link={`/search`}>
                            Skattesøk
                        </AppNav.MenuItem>
                        <AppNav.MenuItem icon="star" link={`/lists`}>
                            Topplister
                        </AppNav.MenuItem>

                        {isAdmin && (
                            <React.Fragment>
                                <AppNav.MenuItem icon="tools" link={`/import`} hidden={!isAdmin}>
                                    Dataimport
                                </AppNav.MenuItem>
                                <AppNav.MenuItem
                                    icon="list"
                                    link={`/geo/counties`}
                                    hidden={!isAdmin}
                                >
                                    Geo-lister
                                </AppNav.MenuItem>
                                <AppNav.MenuItem icon="info" link={`/system`} hidden={!isAdmin}>
                                    Systeminfo
                                </AppNav.MenuItem>
                            </React.Fragment>
                        )}
                    </AppNav.Menu>
                </AppNav>
                <AppContent>
                    <Routes>
                        <Route path="/lists/*" element={<PersonLists />} />
                        <Route path="/lists/:year/*" element={<PersonLists />} />
                        <Route path="/lists/entry/:listId/*" element={<PersonListEdit />} />

                        <Route path="/import/*" element={<DataImport />} />
                        <Route path="/import/tax/:year/*" element={<TaxYearEdit />} />

                        <Route path="/geo/:unitKey" element={<GeoLists />} />

                        <Route path="/system" element={<SystemInfo />} />
                        <Route path="/search" element={<PersonSearch />} />
                        <Route path="/*" element={<Front />} />
                    </Routes>
                </AppContent>
            </AppLayout>
        </AppContainer>
    );
};

export default Root;
